import { createFileRoute } from '@tanstack/react-router';
import { CustomerListPage } from '@/features/customers/CustomerListPage';

/** `?new=customer` ouvre directement le tiroir de création (palette ⌘K). */
export const Route = createFileRoute('/_app/customers/people')({
  validateSearch: (search: Record<string, unknown>): { new?: 'customer' } =>
    search['new'] === 'customer' ? { new: 'customer' } : {},
  component: PeoplePage,
});

function PeoplePage() {
  const search = Route.useSearch();
  return <CustomerListPage kind="PERSON" openNew={search.new === 'customer'} />;
}
